export function isBannerflowEnvironment(adEnvironment) {
    return [
        2 /* AdEnvironment.Preview */,
        4 /* AdEnvironment.ImageGenerator */,
        5 /* AdEnvironment.VideoGenerator */,
        7 /* AdEnvironment.AudioGenerator */,
        6 /* AdEnvironment.Feed */
    ].includes(adEnvironment);
}
